import { useLocation } from "react-router";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function useQuery<T>() {
  return new URLSearchParams(useLocation().search);
}